/**
 * Data Retention is the last step of the Data Map onboarding, so while onboarding it only unlocks
 * once every step before it is done: Vendor List, Data Flows and Vendor Documents (finished or
 * skipped). Vendor Documents can read as finished with nothing in it, so it can't stand in for
 * the steps before it.
 */
export function isDataRetentionNavDisabled({
  isVendorInventoryComplete,
  isDataFlowsComplete,
  isVendorDocumentationProgressionComplete,
}: {
  isVendorInventoryComplete: boolean;
  isDataFlowsComplete: boolean;
  isVendorDocumentationProgressionComplete: boolean;
}): boolean {
  return (
    !isVendorInventoryComplete || !isDataFlowsComplete || !isVendorDocumentationProgressionComplete
  );
}
